import { useState } from "react";
import Modal from "react-modal";
import { useNavigate } from "react-router-dom";
import { useMount } from "react-use";
import { useRecoilState } from "recoil";
import AgreeForm from "../../components/user/AgreeForm";
import InfoForm from "../../components/user/InfoForm";
import SignUpForm from "../../components/user/SignUpForm";
import VerifyForm from "../../components/user/VerifyForm";
import { signItem } from "../../states/atoms/signState";

const SignUpPage = () => {
  const navigate = useNavigate();
  const [{ info }, setSignIn] = useRecoilState(signItem);
  const [step, setStep] = useState(0);
  const [error, setError] = useState(null);
  const [id, setId] = useState(null);
  const [agree, setAgree] = useState({});
  const [modal, setModal] = useState({
    isOpen: false,
    skip: false,
    meesage: "",
  });

  const afterSave = (data) => {
    if (step === 0) {
      setAgree({ overage: data.overage, ad: data.ad });
      localStorage.setItem("tmp", JSON.stringify(data));
    } else if (step === 1 && data) {
      setSignIn({
        result: true,
        info: { ...data, telVerified: false, emailVerified: false },
        error: null,
      });
      localStorage.setItem("token", data.token);
      localStorage.setItem("role", "student");
      localStorage.removeItem("tmp");
      setId(data._id);
    } else if (step === 3) {
      return setModal({
        isOpen: true,
        skip: false,
        message: "회원가입이 완료되었습니다.",
      });
    }
    setStep(step + 1);
  };

  const handleSkip = () => {
    let message = "인증 정보를 나중에 등록하시겠습니까?";
    if (step === 2) {
      message = "추가 정보를 나중에 등록하시겠습니까?";
    }
    return setModal({ isOpen: true, skip: true, message });
  };

  const handleClose = () => {
    setModal({
      isOpen: false,
      skip: false,
      meesage: "",
    });
    switch (info.role) {
      case "student":
        return navigate("/student");
      case "parent":
        return navigate("/parent");
      default:
        return navigate("/");
    }
  };

  useMount(() => {
    const tmp = localStorage.getItem("tmp");
    const token = localStorage.getItem("token");
    if (token) {
      return navigate("/");
    }
    if (tmp) {
      const data = JSON.parse(tmp);
      setAgree({ overage: data.overage, ad: data.ad });
      setStep(1);
    }
  });

  return (
    <div className="hero min-h-screen bg-base-200 place-items-stretch">
      <div className="hero-content flex-col lg:flex-row-reverse m-0 lg:max-w-none">
        <div className="card flex-shrink-0 w-full max-w-sm shadow-2xl bg-base-100">
          {step === 0 && <AgreeForm {...{ afterSave }} />}
          {step === 1 && (
            <SignUpForm {...{ error, setError, agree, afterSave }} />
          )}
          {step === 2 && <InfoForm {...{ id, afterSave, handleSkip }} />}
          {step === 3 && <VerifyForm {...{ id, afterSave, handleSkip }} />}
        </div>
      </div>
      <Modal
        className="h-full text-center flex"
        isOpen={modal.isOpen}
        ariaHideApp={false}
        onRequestClose={handleClose}
      >
        <div className="card max-w-sm w-full bg-white shadow-xl m-auto">
          <div className="card-body overflow-hidden gap-4">{modal.message}</div>
          {modal.skip && (
            <div className="card-actions justify-center gap-0">
              <button
                className="btn w-1/2 flex-auto rounded-r-none rounded-t-none"
                onClick={() =>
                  setModal({
                    isOpen: false,
                    skip: false,
                    meesage: "",
                  })
                }
              >
                아니오
              </button>
              <button
                className="btn btn-primary w-1/2 flex-auto rounded-l-none rounded-t-none"
                onClick={handleClose}
              >
                예
              </button>
            </div>
          )}
          {!modal.skip && (
            <div className="card-actions justify-center">
              <button
                className="w-full btn btn-primary rounded-t-none"
                onClick={handleClose}
              >
                닫기
              </button>
            </div>
          )}
        </div>
      </Modal>
    </div>
  );
};

export default SignUpPage;
